module.exports = __webpack_public_path__ + "img/thumbnail_Caracal_j_melanistic.247f276e.png";